import { render, staticRenderFns } from "./gc-record-two-lines.vue?vue&type=template&id=6f766346&scoped=true"
import script from "./gc-record-two-lines.vue?vue&type=script&lang=js"
export * from "./gc-record-two-lines.vue?vue&type=script&lang=js"
import style0 from "./gc-record-two-lines.vue?vue&type=style&index=0&id=6f766346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f766346",
  null
  
)

export default component.exports